{
  "saved": "Saved",
  "created": "Created",
  "updated": "Updated",
  "deleted": "Deleted",
  "removed": "Removed",
  "submitted": "Submitted for approval",
  "submittedDirect": "Submitted",
  "cancelled": "Cancelled",
  "approved": "Approved",
  "rejected": "Rejected",
  "delegated": "Delegated",
  "uploaded": "Uploaded",
  "downloaded": "Downloaded",
  "exported": "Exported",
  "imported": "Imported",
  "sent": "Sent",
  "copied": "Copied",
  "passwordChanged": "Password changed",
  "sessionRefreshed": "Session refreshed",
  "companyUpdated": "Company updated",
  "settingsSaved": "Settings saved",
  "failed": "Action failed",
  "failedSave": "Failed to save",
  "failedDelete": "Failed to delete",
  "failedLoad": "Failed to load data",
  "failedSubmit": "Failed to submit",
  "networkError": "Network error — check your connection",
  "permissionDenied": "You do not have permission for this action",
  "selectCompany": "Select a company in the header first",
  "requiredFields": "Please fill in all required fields",
  "invalidAmount": "Enter a valid amount",
  "passwordsMismatch": "Passwords do not match",
  "workingIn": "Working in {{name}}",
  "companySwitchFailed": "Could not switch companies. Your previous company remains active.",
  "moduleAccessDenied": "You do not have access to this module",
  "planUpgradeRequired": "Upgrade your plan to unlock this feature",
  "hrRosterCopied": "Copied {{count}} roster assignment(s)",
  "hrRosterPublished": "Roster published for the week",
  "hrPayrollHandoffExported": "Payroll handoff CSV downloaded",
  "hrLaborRulesSaved": "Labor rules saved"
}
